<template>
  <div class="knowledge-exam-list-page">
    <title-bar title="体育健康知识"> </title-bar>

    <div class="main" v-if="examList.length">
      <exam-card
        v-for="(exam, index) in examList"
        :exam="exam"
        :key="index"
        @remove="handleRemove(exam)"
        @updateName="showUpdateNamePopup(exam)"
        @updateTime="showUpdatePopup(exam)"
        @navToExamSummary="navToExamSummary"
      ></exam-card>
    </div>

    <div class="empty" v-else>
      <img src="./assets/img_exam_empty@2x.png" />
      <el-button @click="navToRepo"> 从知识库布置</el-button>
    </div>

    <el-dialog
      @confirm="updateChallengeTime"
      width="486px"
      center
      title="调整考试时间"
      :visible.sync="updateTimePopupVisible"
      v-if="selectItem"
      class="update-exam-time-dialog"
    >
      <el-form inline>
        <el-form-item label="开始日期">
          <el-date-picker v-model="selectItem.start_datetime"></el-date-picker>
        </el-form-item>

        <el-form-item label="考试时间">
          <el-time-picker format="HH:mm" v-model="time"></el-time-picker>
        </el-form-item>

        <el-form-item label="考试时长">
          <el-select v-model="duration">
            <el-option v-for="item in durationOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button @click="updateTimePopupVisible = false"> 取消</el-button>
        <el-button type="primary" @click="updateChallengeTime"> 确认</el-button>
      </div>
    </el-dialog>

    <update-name-popup
      :visible.sync="updateNamePopupVisible"
      :name="updateName"
      @confirm="updateExamName"
    ></update-name-popup>
  </div>
</template>
<script lang="ts">
import { BasePage, Component, Watch } from 'kuaidong-component'
import TitleBar from '@/components/TitleBar.vue'
import { ITeacherPaperExamItem } from 'kuaidong-model'
import { DateUtil, DateWrapper } from 'kuaidong-lib'
import { TeacherService } from 'kuaidong-service'
import { AWinter2023 } from 'kuaidong-api'
import { KDMessageBox } from 'kuaidong-ui'
import ExamCard from '@/views/pe-knowledge/components/ExamCard.vue'
import UpdateNamePopup from '@/views/pe-knowledge/components/UpdateNamePopup.vue'
@Component({
  components: {
    TitleBar,
    ExamCard,
    UpdateNamePopup,
  },
})
export default class KnowledgeExamListPage extends BasePage {
  updateTimePopupVisible = false
  updateNamePopupVisible = false
  selectItem: ITeacherPaperExamItem | null = null
  updateName = ''
  teacherExamList: ITeacherPaperExamItem[] = []
  duration = 120

  get time() {
    return new DateWrapper((this.selectItem as ITeacherPaperExamItem).start_datetime).date
  }

  set time(time: Date) {
    if (this.selectItem) {
      this.selectItem.start_datetime = DateUtil.mergeDateAndTime(
        new DateWrapper(this.selectItem.start_datetime).date,
        new DateWrapper(time).showTimeStr
      )
    }
  }

  get durationOption() {
    return [30, 60, 90, 120, 150, 180].map((n) => {
      return {
        value: n,
        label: `${n}分钟`,
      }
    })
  }

  get examList() {
    return this.teacherExamList.map((item) => {
      return {
        ...item,
        title: item.title,
        status: this.formatProgress(item.status),
        clazzName:
          item.class_vo_list.length > 1
            ? `${item.class_vo_list[0].note_name || item.class_vo_list[0].name} 等${item.class_vo_list.length}个班级`
            : item.class_vo_list[0].note_name || item.class_vo_list[0].name,

        date: `${this.formatDate(item.start_datetime)}~${this.formatDate(item.end_datetime)}`,
        creator: TeacherService.buildName(item.teacher_vo.teacher_name),
      }
    })
  }

  assign() {
    this.$routerHelper.navToQuestionBank()
  }

  formatDate(dt: Date) {
    return new DateWrapper(dt).showDateStr2
  }

  formatTime(time: string) {
    if (time) {
      return time.split(':')
    }
    return time
  }

  navToRepo() {
    this.$router.push({ name: 'pe_knowledge_repo' })
  }

  async created() {
    this.fetchPaperExamList()
  }

  async fetchPaperExamList() {
    this.teacherExamList = await AWinter2023.teacherPaperExamList()
  }

  navToExamSummary(exam: any) {
    return this.$router.push({
      name: 'pe_knowledge_exam_clazz_detail',
      query: {
        id: exam.online_exam_id,
      },
    })
  }

  formatProgress(status: string) {
    if (status === 'UN_START') {
      return '未开始'
    } else if (status === 'STARTED') {
      return '进行中'
    } else {
      return '已结束'
    }
  }

  async handleRemove(examInfo: ITeacherPaperExamItem) {
    const ok = await KDMessageBox.confirm('', '是否删除该考试！', {
      cancelButtonText: '取消',
      confirmButtonText: '确认删除',
      confirmButtonType: 'danger',
    })
    if (ok) {
      try {
        await AWinter2023.deleteTeacherPaperExam(examInfo.online_exam_id)
        this.toast('删除考试成功~')
        this.fetchPaperExamList()
      } catch (e) {
        this.toast('删除考试失败~')
      }
    }
    return
  }

  showUpdatePopup(selectItem: ITeacherPaperExamItem) {
    this.selectItem = selectItem
    this.updateTimePopupVisible = true
  }

  showUpdateNamePopup(selectItem: ITeacherPaperExamItem) {
    this.selectItem = selectItem
    this.updateName = this.selectItem.title
    this.updateNamePopupVisible = true
  }

  async updateExamName(name: string) {
    try {
      if (this.selectItem) {
        this.selectItem.title = name
      }
      await this.updateChallenge()
      this.$message.success('考试名称已更新~')
    } catch (e) {
      this.$message.error('更新考试名称发生错误~')
    }
  }

  async updateChallengeTime() {
    if (this.validate()) {
      try {
        await this.updateChallenge()
        this.$message.success('考试时间已更新~')
        this.updateTimePopupVisible = false
      } catch (e) {
        this.$message.error('更新时间发生错误~')
      }
    }
  }

  async updateChallenge() {
    if (this.selectItem) {
      const form = {
        online_exam_id: this.selectItem.online_exam_id,
        name: this.selectItem.title,
        start_datetime: this.selectItem.start_datetime,
        end_datetime: this.selectItem.end_datetime,
      }
      await AWinter2023.updatePaperExam(form)
      this.fetchPaperExamList()
    }
  }

  validate() {
    if (this.selectItem) {
      const start = new DateWrapper(this.selectItem.start_datetime)

      if (this.selectItem.end_datetime) {
        const end = new DateWrapper(this.selectItem.end_datetime)
        if (end.date < start.date) {
          this.toast('结束时间不能小于开始时间~')
          return false
        }
      } else {
        this.toast('请选择结束时间~')
      }
      return true
    } else {
      return false
    }
  }

  @Watch('selectItem.start_datetime', { immediate: true })
  updateEndTimeByStart() {
    if (this.selectItem) {
      this.selectItem.end_datetime = DateUtil.addMinutes(
        new DateWrapper(this.selectItem.start_datetime).date,
        this.duration
      )
    }
  }
}
</script>
<style lang="less">
.knowledge-exam-list-page {
  > .main {
    padding: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    > .exam-card-comp {
      margin-right: 20px;
      margin-bottom: 30px;
    }
  }

  > .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > img {
      width: 130px;
      height: 158px;
    }
    > .el-button {
      background: #ffffff;
      border: 1px solid #2981f8;
      border-radius: 4px;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: #2981f8;
      padding: 9px 38px;
      margin-top: 33px;
    }
  }
  > .update-exam-time-dialog {
    > .el-dialog {
      padding: 0 20px;

      > .el-dialog__header {
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        color: #0a1629;
      }
      > .el-dialog__body {
        display: flex;
        flex-direction: column;
        border-radius: 16px;
        flex: auto;
        padding: 0;
        text-align: left;
        overflow: hidden;
        > .el-form {
          > .el-form-item {
            > .el-form-item__content {
              > .el-input,
              .el-select {
                width: 350px;
              }
            }
          }
        }

        > .footer {
          flex: none;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 0 40px 0;
          > .el-button {
            width: 135px;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>
